export const FORM_KEY_TO = 'to'
export const FORM_KEY_SUBJECT = 'subject'
export const FORM_KEY_CUSTOM_MESSAGE = 'customMessage'
export const FORM_KEY_FROM = 'from'
export const FORM_KEY_INCLUDE_BCC = 'includeBcc'
